function initializeEventFilter(sectionId) {
   var eventSection = document.getElementById(sectionId);
   if (!eventSection) {
      console.log('Event section not found:', sectionId);
      return;
   }

   // Predefined order of states
   var predefinedOrder = ['QLD', 'NSW', 'VIC', 'WA', 'International'];

   // Select all elements with a data-state attribute and convert NodeList to Array
   const stateElements = Array.from(document.querySelectorAll('.event-item[data-state]'));

   // Use a Set to store unique states
   const uniqueStates = new Set();

   // Extract the state and add it to the Set
   stateElements.forEach(element => {
      const state = element.getAttribute('data-state');
      uniqueStates.add(state);
   });

   // Convert the Set to an Array
   const allStates = Array.from(uniqueStates);

   // Separate states into those in predefinedOrder and new states
   const orderedStates = allStates.filter(state => predefinedOrder.includes(state));
   const newStates = allStates.filter(state => !predefinedOrder.includes(state));

   // Combine orderedStates and newStates
   const finalStates = [...orderedStates.sort((a, b) => predefinedOrder.indexOf(a) - predefinedOrder.indexOf(b)), ...newStates];

   var availableStates = [];

   var eventItems = eventSection.querySelectorAll('.event-item');
   for (var i = 0; i < eventItems.length; i++) {
      var state = eventItems[i].getAttribute('data-state');
      if (state && finalStates.indexOf(state) !== -1 && availableStates.indexOf(state) === -1) {
         availableStates.push(state);
      }
   }

   // Ensure availableStates matches the final order
   availableStates.sort(function(a, b) {
      return finalStates.indexOf(a) - finalStates.indexOf(b);
   });

   var filterContainer = eventSection.querySelector('.filter-buttons');
   filterContainer.innerHTML = '';

   availableStates.forEach(function(state, index) {
      var button = document.createElement('button');
      button.className = 'state-filter';
      button.setAttribute('data-state', state);
      button.textContent = state;
      filterContainer.appendChild(button);

      // Set the first button as active initially
      if (index === 0) {
         button.classList.add('active');
         // Show items for the first state
         animateItemsForState(state);
      }
   });

   function animateItemsForState(state) {
      // Fade in items for the selected state
      var eventItemsToShow = Array.prototype.filter.call(eventItems, function(item) {
         return item.getAttribute('data-state') === state;
      });

      // Set display block to all items that will be shown
      eventItemsToShow.forEach(function(item) {
         item.style.display = 'block';
      });

      gsap.to(eventItemsToShow, {
         autoAlpha: 1,
         y: 0,
         duration: 0.3,
         stagger: 0.1,
         ease: "power4.out"
      });
   }

   var filterButtons = filterContainer.querySelectorAll('.state-filter');

   for (var j = 0; j < filterButtons.length; j++) {
      filterButtons[j].addEventListener('click', function() {
         var selectedState = this.getAttribute('data-state');

         // Fade out all items first
         gsap.to(eventItems, {
            autoAlpha: 0,
            y: 20,
            duration: 0.1,
            stagger: 0.0,
            ease: "power4.out",
            onComplete: function() {
               // After fade out, set display none to all items except those that match the selected state
               Array.prototype.forEach.call(eventItems, function(item) {
                  if (item.getAttribute('data-state') !== selectedState) {
                     item.style.display = 'none';
                  }
               });

               // Then, animate the items that match the selected state
               animateItemsForState(selectedState);
            }
         });

         // Update active class on buttons
         for (var l = 0; l < filterButtons.length; l++) {
            filterButtons[l].classList.remove('active');
         }
         this.classList.add('active');
      });
   }
}
